<template>
    <div class="w-full bg-white border border-gray-100 rounded-lg shadow-sm px-5 sm:px-6 pt-6 pb-8">
      <h1
        class="text-base sm:text-lg text-center lg:text-left font-semibold text-gray-900"
      >
        Retailer to Retailer Data Transfer
      </h1>

      <form action="" class="mt-6 w-full flex flex-col items-center">
        <div class="grid md:grid-cols-2 xl:grid-cols-3 gap-5 w-full">
          <div class="flex flex-col sm:flex-row sm:items-center sm:space-x-4">
            <label for="from" class="text-sm font-medium text-expressgray mb-2 sm:mb-0">From:</label>

            <input
              type="text"
              name="fromPhone"
              id="fromPhone"
              v-model="fromPhone"
              placeholder="Phone number"
              class="outline-none bg-white h-10 border border-gray-200 rounded-lg w-full px-3 text-sm focus:border-express"
            />
          </div>

          <div class="flex flex-col sm:flex-row sm:items-center sm:space-x-4">
            <label for="to" class="text-sm font-medium text-expressgray mb-2 sm:mb-0">To:</label>

            <input
              type="text"
              name="toPhone"
              id="toPhone"
              v-model="toPhone"
              placeholder="Phone number"
              class="outline-none bg-white h-10 border border-gray-200 rounded-lg w-full px-3 text-sm focus:border-express"
            />
          </div>


          <div class="flex flex-col sm:flex-row sm:items-center sm:space-x-4">
            <label for="from" class="text-sm font-medium text-expressgray mb-2 sm:mb-0">Amount:</label>

            <input
              type="number"
              name="amount"
              id="amount"
              v-model="creditAmount"
              placeholder="amount"
              class="outline-none bg-white h-10 border border-gray-200 rounded-lg w-full px-3 text-sm focus:border-express"
            />
          </div>
        </div>

        <input
          type="submit"
          name="transfer"
          id="transfer"
          @click.prevent="submit"
          value="Transfer"
          :disabled="!buttonDisabled"
          class="mt-9 rounded-lg text-white text-sm font-medium h-11 w-full sm:w-56 mx-auto transition-colors"
          :class="
            !buttonDisabled
              ? 'bg-express/40 cursor-not-allowed'
              : 'bg-express hover:bg-expressbutton cursor-pointer'
          "
        />
      </form>

      <div v-if="isTransferLoading" class="mt-5 mx-3">
        <loading message=""></loading>
      </div>
    </div>
  </template>
  
  <script setup>
  import { onMounted, watch } from "vue";
  import { computed, ref } from "vue";
  import { useToast } from "vue-toast-notification";
  import { useStore } from "vuex";
  import { useRouter } from "vue-router";
  import { isValidMACAddress } from "@/utils/globalFunctions.js";
  
  const store = useStore();
  const $toast = useToast();
  const $router = useRouter();
  
  const isLoading = ref(false);
  const isTransferLoading = ref(false);
  const fromPhone = ref("");
  const toPhone = ref("");
  const creditAmount = ref(0);
//   const plans = computed(() => store.getters["products/products"]);
  
  const buttonDisabled = computed(() => {
    console.log(creditAmount.value);
    
    return (
        fromPhone.value.length >= 10 &&
        toPhone.value.length >= 10 &&
        creditAmount.value > 0
    );
  });

//   onMounted(async () => {
//     await fetchPlans(currency.value);
//   });
  
//   watch(currency, async (newCurrency) => {
//     selected_plan.value = [];
//     await fetchPlans(newCurrency);
//   });
  
  const submit = async () => {

  
    if (fromPhone.value.length < 10) {
      $toast.error("Check phone number validity", {
        position: "top-right",
        duration: 4500,
      });
      return;
    }

    if (toPhone.value.length < 10) {
      $toast.error("Check phone number validity", {
        position: "top-right",
        duration: 4500,
      });
      return;
    }

    if (creditAmount.value.length <= 0) {
      $toast.error("Check amount validity", {
        position: "top-right",
        duration: 4500,
      });
      return;
    }

  
    isTransferLoading.value = true;
  
    await store.dispatch("admins/transferCreditBetweenRetailers", {
      fromPhone: fromPhone.value,
      toPhone: toPhone.value,
      amount: creditAmount.value,
      toast: $toast,
      router: $router,
    });
    isTransferLoading.value = false;
  
    toPhone.value = "";
  };
  </script>
  